import React from 'react';
import './AboutMe.css';

const profiles = [
  {
    name: 'Richa Hansraj',
    role: 'Transformation Lead',
    image: '/assets/images/headshot.png',
    linkedin: 'https://www.linkedin.com/in/richa-hansraj/',
    summary: '18+ years across Google, Samsung and Snapdeal, spanning operations, transformation, automation and creative strategy.',
    proof: '$2B+ business impact; 33,000+ campaigns; Gold & Silver awards for process automation.'
  },
  {
    name: 'Vajreshwari Das',
    role: 'Governance Lead',
    image: '/assets/images/vajreshwari-das.jpeg',
    linkedin: 'https://www.linkedin.com/in/vajreshwaridas/',
    summary: '15+ years across UK public-sector ICT, AI governance, assurance and responsible technology adoption.',
    proof: 'ISO/IEC 42001:2023 Lead Auditor; PRINCE2 & AgilePM Practitioner; Microsoft for Sovereignty.'
  }
];

const AboutMe = () => {
  return (
    <section className="about section" id="about">
      <div className="container">
        <div className="about-header">
          <span className="label">LEADERSHIP</span>
          <h2 className="about-title">Meet the Team</h2>
        </div>

        <div className="people-grid" id="why-choose">
          {profiles.map((profile) => (
            <article className="profile-card" key={profile.name}>
              <div className="profile-image-wrap">
                <img src={profile.image} alt={profile.name} className="profile-image" />
                <a
                  className="profile-social"
                  href={profile.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`View ${profile.name}'s LinkedIn profile (opens in a new tab)`}
                  title={`${profile.name} on LinkedIn`}
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28ZM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12ZM6.96 20.45H3.71V9h3.25v11.45ZM22.23 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.46c.98 0 1.77-.77 1.77-1.73V1.73C24 .77 23.21 0 22.23 0Z" />
                  </svg>
                </a>
              </div>
              <div className="profile-copy">
                <h3 className="profile-name">{profile.name}</h3>
                <p className="profile-role">{profile.role}</p>
                <p className="profile-summary">{profile.summary}</p>
                <p className="profile-proof"><span>Proof</span>{profile.proof}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
